<div class="background-container">
  <div class="inner-container">
    <div class="image-with-caption">
      <img src="../../../assets/images/404.jpg" class="image" />
      <div class="captions-container">
        <div class="text-404">404 - Page not found</div>
        <div class="link-container">
          <a href="/" class="link-to-main">Return to main</a>
        </div>
      </div>
    </div>
  </div>
</div>
